import React from 'react';
import { usePaginationOffset } from 'hooks';

export default Component => props => {
    const [paginationOffset] = usePaginationOffset();

    return <Component {...props} paginationOffset={paginationOffset} />;
};
